import { Typography } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import React, { FC } from 'react'

export interface SectionWrapperProps {
  headline: string
  currentSlide: number
}

const useStyles = makeStyles((theme) =>
  createStyles({
    sectionWrapper: {
      position: 'relative',
      padding: '32px 48px 24px',
      margin: '0 28px',
      height: '100%',
      boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'hidden',
      minHeight: 475,
      backgroundColor: '#98C1C4',
      justifyContent: 'space-between',
      overflow: 'hidden',
      zIndex: 15,
      [theme.breakpoints.down('sm')]: {
        margin: 0,
        padding: '24px 20px',
      },
      '&:after': {
        position: 'absolute',
        bottom: 0,
        left: '50%',
        content: '""',
        transform: 'translateX(-50%)',
        width: '100%',
        height: '30%',
        zIndex: -99,
        clipPath: 'polygon(50% 0, 100% 100%, 0 100%)',
        backgroundColor: '#AACCCD',
      },
    },
    headline: {
      fontSize: 28,
      color: '#FFFFFF',
      textTransform: 'uppercase',
    },
    pagination: {
      fontSize: 18,
      textTransform: 'uppercase',
    },
  }),
)

const SectionWrapper: FC<SectionWrapperProps> = ({
  headline,
  currentSlide,
  children,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.sectionWrapper}>
      <Typography align="center" className={classes.headline} variant="h2">
        {headline}
      </Typography>
      <Typography
        align="center"
        className={classes.pagination}
        color="primary"
        component="p"
        variant="body2"
      >
        {currentSlide + 1} of 3
      </Typography>
      {children}
      <div className="test" />
    </div>
  )
}

export default SectionWrapper
